import { render, staticRenderFns } from "./WorkshopOrder.vue?vue&type=template&id=de1b4f92&scoped=true"
import script from "./WorkshopOrder.vue?vue&type=script&lang=js"
export * from "./WorkshopOrder.vue?vue&type=script&lang=js"
import style0 from "./WorkshopOrder.vue?vue&type=style&index=0&id=de1b4f92&prod&lang=scss"
import style1 from "./WorkshopOrder.vue?vue&type=style&index=1&id=de1b4f92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1b4f92",
  null
  
)

export default component.exports